import React, { useEffect, useContext, useState } from 'react';
import { Accordion, Loader } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { Waypoint } from 'react-waypoint';
import ScrollToTopButton from '../../../shared/scrollToTopBtn/content';
import {
  selectOrgUnit,
  updateOrgUnitSearch,
  getEntitiesWithSearchTerm,
  resetEntitySearchForm,
  updateEntitySearchForm,
  updateCurrentActivePageNo,
  getWAByIdWithSearchTerm,
  getMRByIdWithSearchTerm,
} from '../../../../actions/organisation';
import { selectMeetingRoom, getMeetingRoomDetails } from 'actions/meetingRoom';
import { selectWaitingAreaEntity } from '../../../../actions/waitingArea';
import { SettingMenuContext } from './content';
import SearchContainer from './searchContainer';
import {
  FilterDropdownMarkUp,
  NoResultMarkUp,
  OrgUnit1stChildTreeView,
  OrgUnitTitleContent,
  WaitingAreaRowMarkup,
  WaitingAreaRowMarkupWithoutMenu,
  MeetingRoomRowMarkup,
  MeetingRoomRowMarkupWithoutMenu,
  childEntityCountsMarkup,
  getSearchString,
  checkViewOrgMenuCapability,
  checkViewWAMenuCapability,
  checkViewMRMenuCapability,
} from './entityRowMarkup';

export default function CenterPanel(props) {
  const {
    fetchingIndicator,
    entityFilter,
    orgSetting,
    waSetting,
    mrSetting,
    selectedOrgUnit,
    selectedWaitingArea,
    selectedMeetingRoom,
    openOrgTreeViewArray,
    searchBar,
    highlightOrgs,
    highlightWAs,
    highlightMRs,
    searchIndicator,
  } = useContext(SettingMenuContext);

  const [highlightOrgUnits, setHighlightSelectedOrgUnits] = highlightOrgs;
  const [filterValue, setFilterValue] = entityFilter;
  const [fetchingOrgs, setFetchingOrgs] = fetchingIndicator;
  const [openOrgSettingMenu, setOpenOrgSettingMenu] = orgSetting;
  const [openWASettingMenu, setOpenWASettingMenu] = waSetting;
  const [openMRSettingMenu, setOpenMRSettingMenu] = mrSetting;
  const [treeViewActiveIndex, setTreeViewActiveIndex] = openOrgTreeViewArray;
  const [searchTermSubmitted, setSearchTermSubmitted] = searchBar;
  const [highlightWaitingAreas, setHighlightWaitingAreas] = highlightWAs;
  const [highlightMeetingRooms, setHighlightMeetingRooms] = highlightMRs;
  const [newSearchIndicator, setNewSearchIndicator] = searchIndicator;

  const [oldFilterValue, setOldFilterValue] = useState(entityFilter[0]);

  const dispatch = useDispatch();

  useEffect(() => {
    // Reset scroll position to the top, when this component is re-rendered
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // When filter is changed, need to refresh the search
    if (oldFilterValue != filterValue) {
      setOldFilterValue(filterValue);
      newSearchDone();
      setHighlightSelectedOrgUnits([]);
      setHighlightWaitingAreas([]);
      setHighlightMeetingRooms([]);
    }
  }, [filterValue]);

  useEffect(() => {
    // newSearchIndicator is a value changed whenever need to do a new search but filter value is not changed
    // By incrementing newSearchIndicator's number, it will execute the functions inside that
    // Initially newSearchIndicator == 0, and it won't execute the methods inside when it's 0;
    // because useEffect for filterValue has been executed when page initialised, so to avoid 2 calls for search api
    if (newSearchIndicator > 0) {
      // To force a new search
      newSearchDone();
      setHighlightSelectedOrgUnits([]);
      setHighlightWaitingAreas([]);
      setHighlightMeetingRooms([]);
    }
  }, [newSearchIndicator]);

  useEffect(() => {
    // newIndexArray is an array of objects { networkId: orgUnit.networkId, open: true / false }
    // it records for each loaded org unit tree view's statis to be open or Closed
    let newIndexArray = [...treeViewActiveIndex];
    if (filterValue === 2) {
      // When filter is WA, tree view should be open by default
      props.organisations.map((orgUnit) => {
        if (
          orgUnit.waitingAreas &&
          orgUnit.waitingAreas.length > 0 &&
          !treeViewActiveIndex.some((x) => x.networkId === orgUnit.networkId)
        ) {
          // if previous treeViewActiveIndex has recored this org unit's tree view status, we don't need to push it in the array
          // if this org unit's tree view status is not yet recorded, push it in the array
          newIndexArray.push({ networkId: orgUnit.networkId, open: true });
          newIndexArray = _.uniq(newIndexArray, 'networkId');
        }
      });
    } else if (filterValue === 3) {
      // When filter is MR, tree view should be open by default
      props.organisations.map((orgUnit) => {
        if (
          orgUnit.meetingRooms &&
          orgUnit.meetingRooms.length > 0 &&
          !treeViewActiveIndex.some((x) => x.networkId === orgUnit.networkId)
        ) {
          // if previous treeViewActiveIndex has recored this org unit's tree view status, we don't need to push it in the array
          // if this org unit's tree view status is not yet recorded, push it in the array
          newIndexArray.push({ networkId: orgUnit.networkId, open: true });
          newIndexArray = _.uniq(newIndexArray, 'networkId');
        }
      });
    } else if (filterValue === 1) {
      // When filter is Org, only open those with leaves matched
      props.organisations.map((orgUnit, i) => {
        if (
          ((orgUnit.waitingAreas && orgUnit.waitingAreas.length > 0) ||
            (orgUnit.meetingRooms && orgUnit.meetingRooms.length > 0)) &&
          !treeViewActiveIndex.some((x) => x.networkId === orgUnit.networkId)
        ) {
          newIndexArray.push({ networkId: orgUnit.networkId, open: true });
          newIndexArray = _.uniq(newIndexArray, 'networkId');
        }
      });
    }
    setTreeViewActiveIndex(newIndexArray);
  }, [props.organisations.length]);

  const newSearchDone = () => {
    submitSearchTerm(true);
    setTreeViewActiveIndex([]);
    props.closeMenu();
  };

  const filterOnChange = (event, data) => {
    // Change the search criteria to be selected entity
    // Clear search term then submit a search
    let oldFilterValue = filterValue;
    setFilterValue(data.value);
    if (oldFilterValue != data.value) {
      // only when filter value is change, reset the search term
      setFetchingOrgs(false);
      changeSearchTerm('', false);
    }
  };

  const onSearchTermInputChange = (event) => {
    if (event.target != undefined) changeSearchTerm(event.target.value, false);
    else changeSearchTerm(event, false);
  };

  const clearSearchTerm = () => {
    changeSearchTerm('', false);
    setTimeout(() => {
      submitSearchTerm();
      setTreeViewActiveIndex([]);
    }, 500);
  };

  const changeSearchTerm = (searchString, searchTermSubmitted) => {
    dispatch(updateOrgUnitSearch(searchString));
    setSearchTermSubmitted(searchTermSubmitted);
  };

  const submitSearchTerm = (isFormSubmitted = false) => {
    let searchString = getSearchString();
    changeSearchTerm(searchString, isFormSubmitted);
    // Clear grayed rows background colour
    props.closeMenu();
    if (searchString && searchString != '') {
      setHighlightSelectedOrgUnits([]);
      setHighlightWaitingAreas([]);
    }
    if (!fetchingOrgs) {
      // Reset orgs list form
      dispatch(resetEntitySearchForm());

      // Store current search string
      let currentActivePageNo = 0;
      let fetchingPageNo = currentActivePageNo + 1;

      let entitySearchPayLoad = {
        searchString: searchString.trim(),
        pageNo: fetchingPageNo,
      };
      dispatch(updateEntitySearchForm(entitySearchPayLoad));
      setFetchingOrgs(true);
      let cb = (moreEntitiesReturned) => {
        setFetchingOrgs(false);

        if (moreEntitiesReturned) {
          // Once data fetch finishes and fetched meetingrooms.length > 0, the active page no needs to be increased by 1
          dispatch(updateCurrentActivePageNo(1));
        }
      };
      // Get entities based on search term and filter value
      dispatch(getEntitiesWithSearchTerm(entitySearchPayLoad, filterValue, cb));
    }
  };

  const handleWaypointEnter = () => {
    let currentActivePageNo = props.entitySearchForm.currentActivePageNo;
    let fetchingPageNo = currentActivePageNo + 1;

    // Check if WAs reached the max 1
    let loadedWACount = 0;
    let loadedMRCount = 0;
    if (filterValue === 2) {
      // The back end will return totalRows in the search result;
      // front end will compare loaded set's length with totalRows to see if more entities need to load when reaching page bottom
      // For waiting areas, totalRows means number of waiting areas that match the search term
      // Front end need to sum up all waiting areas loaded under each org to get number of current loaded WAs to compare with totalRows
      loadedWACount = _.sumBy(props.organisations, (org) => {
        return org.waitingAreas.length;
      });
    } else if (filterValue === 3) {
      // The back end will return totalRows in the search result;
      // front end will compare loaded set's length with totalRows to see if more entities need to load when reaching page bottom
      // For waiting areas, totalRows means number of waiting areas that match the search term
      // Front end need to sum up all waiting areas loaded under each org to get number of current loaded WAs to compare with totalRows
      loadedMRCount = _.sumBy(props.organisations, (org) => {
        return org.meetingRooms.length;
      });
    }

    if (
      props.entitySearchForm.totalRowsForSet == null ||
      (filterValue === 1 && props.organisations.length < props.entitySearchForm.totalRowsForSet) ||
      (filterValue === 2 && loadedWACount < props.entitySearchForm.totalRowsForSet) ||
      (filterValue === 3 && loadedMRCount < props.entitySearchForm.totalRowsForSet)
    ) {
      // When type is org, check if max rows limit has been reached
      if (!fetchingOrgs) {
        setFetchingOrgs(true);

        let cb = (moreOrgsReturned) => {
          setFetchingOrgs(false);

          if (moreOrgsReturned) {
            // Once data fetch finishes, the active page no needs to be increased by 1
            dispatch(updateCurrentActivePageNo(1));
          }

          if (props.entitySearchForm.searchString.trim() != '' && !searchTermSubmitted) {
            // When there's a search string and successful returned, searchTermSubmitted should be true to show the x
            setSearchTermSubmitted(true);
          }
        };

        let entitySearchPayLoad = {
          searchString: props.entitySearchForm.searchString.trim(),
          pageNo: fetchingPageNo,
        };
        // Get entities based on search term and filter value
        dispatch(getEntitiesWithSearchTerm(entitySearchPayLoad, filterValue, cb));
      }
    }
  };

  const showOrgMenu = (orgUnit, event) => {
    dispatch(selectOrgUnit(orgUnit));
    setOpenOrgSettingMenu(true);
  };

  const showWAMenu = (waitingArea, event) => {
    dispatch(selectWaitingAreaEntity(waitingArea));
    setOpenWASettingMenu(true);
  };

  const showMRMenu = (meetingRoom, event, getMRDetail, extraNameCheck) => {
    if (getMRDetail) {
      // When filter is MR, it need to get extra mr details
      let cb = (data) => {
        if (extraNameCheck) {
          // Extra check if name matched search term
          let searchString = getSearchString();
          let regex = new RegExp(searchString, 'gi');
          if (data.name && !regex.test(data.name)) {
            return;
          }
        }
        dispatch(selectMeetingRoom(data));
        setOpenMRSettingMenu(true);
      };
      dispatch(getMeetingRoomDetails(meetingRoom.id, cb));
    } else {
      dispatch(selectMeetingRoom(meetingRoom));
      setOpenMRSettingMenu(true);
    }
  };

  // This function is called when clicking the hambergur bar of the right of org unit row, when it's visible
  // It will open / close RHS menu; deselect the row if menu is open
  const orgUnitHamBarOnClickMobile = (event, orgUnit, closeMenu) => {
    setHighlightWaitingAreas([]);
    setHighlightMeetingRooms([]);
    setOpenWASettingMenu(false);
    setOpenMRSettingMenu(false);
    if (highlightOrgUnits[0] === orgUnit.networkId) {
      if (!openOrgSettingMenu) {
        setHighlightSelectedOrgUnits([orgUnit.networkId]);
        showOrgMenu(orgUnit, event);
      } else {
        props.closeMenu();
      }
    } else {
      setOpenOrgSettingMenu(false);
      setHighlightSelectedOrgUnits([orgUnit.networkId]);
    }
    event.stopPropagation();
  };

  // A waiting area row is divided in to 2 parts:
  // Waiting area name & hambergur bar; clicking each part will trigger different behaviour
  // This function is called when clickign waiting area name
  // It will select / deselect an WA row and close RHS menu
  const waTextOnClickDesktop = (event, waitingArea, closeMenu) => {
    closeMenu();
    setHighlightSelectedOrgUnits([]);
    setHighlightMeetingRooms([]);
    if (highlightWaitingAreas[0] === waitingArea.id) {
      setHighlightWaitingAreas([]);
      closeMenu();
    } else {
      setHighlightWaitingAreas([waitingArea.id]);
      let cb = (data) => {
        setTimeout(() => {
          showWAMenu(data, event);
        }, 50);
      };
      dispatch(getWAByIdWithSearchTerm(waitingArea.id, waitingArea.orgNetworkId, cb));
    }
    event.stopPropagation();
  };

  const waTextOnClickMobile = (event, waitingArea, closeMenu) => {
    closeMenu();
    setHighlightSelectedOrgUnits([]);
    setHighlightMeetingRooms([]);
    if (highlightWaitingAreas[0] === waitingArea.id) {
      setHighlightWaitingAreas([]);
    } else {
      setHighlightWaitingAreas([waitingArea.id]);
    }

    dispatch(getWAByIdWithSearchTerm(waitingArea.id, waitingArea.orgNetworkId));
    event.stopPropagation();
  };

  // This function is called when clicking the hambergur bar of the right of waiting area row, when it's visible
  // It will open / close RHS menu; deselect the row if menu is open
  const waHamBarOnClickMobile = (event, waitingArea, closeMenu) => {
    setHighlightSelectedOrgUnits([]);
    setHighlightMeetingRooms([]);
    setOpenOrgSettingMenu(false);
    setOpenMRSettingMenu(false);
    if (highlightWaitingAreas[0] === waitingArea.id) {
      if (!openWASettingMenu) {
        setHighlightWaitingAreas([waitingArea.id]);
        showWAMenu(waitingArea, event);
      } else {
        props.closeMenu();
      }
    } else {
      setOpenWASettingMenu(false);
      setHighlightWaitingAreas([waitingArea.id]);
    }
    event.stopPropagation();
  };

  // A meeting room row is divided in to 2 parts:
  // Meeting room name & hambergur bar; clicking each part will trigger different behaviour
  // This function is called when clickign meeting room name
  // It will select / deselect an MR row and close RHS menu
  const mrTextOnClickDesktop = (event, meetingRoom, closeMenu) => {
    closeMenu();
    setHighlightSelectedOrgUnits([]);
    setHighlightWaitingAreas([]);
    if (highlightMeetingRooms[0] === meetingRoom.id) {
      setHighlightMeetingRooms([]);
      closeMenu();
    } else {
      setHighlightMeetingRooms([meetingRoom.id]);
      if (filterValue === 3) {
        showMRMenu(meetingRoom, event, true, true);
        dispatch(getMRByIdWithSearchTerm(meetingRoom.id, meetingRoom.organisationNetworkId));
      } else {
        let cb = (data) => {
          showMRMenu(data, event);
        };
        dispatch(getMRByIdWithSearchTerm(meetingRoom.id, meetingRoom.organisationNetworkId, cb));
      }
    }
    event.stopPropagation();
  };

  const mrTextOnClickMobile = (event, meetingRoom, closeMenu) => {
    closeMenu();
    setHighlightSelectedOrgUnits([]);
    setHighlightWaitingAreas([]);
    if (highlightMeetingRooms[0] === meetingRoom.id) {
      setHighlightMeetingRooms([]);
    } else {
      setHighlightMeetingRooms([meetingRoom.id]);
    }
    dispatch(getMRByIdWithSearchTerm(meetingRoom.id, meetingRoom.orgNetworkId));
    event.stopPropagation();
  };

  // This function is called when clicking the hambergur bar of the right of waiting area row, when it's visible
  // It will open / close RHS menu; deselect the row if menu is open
  const mrHamBarOnClickMobile = (event, meetingRoom, closeMenu) => {
    setHighlightSelectedOrgUnits([]);
    setHighlightWaitingAreas([]);
    setOpenOrgSettingMenu(false);
    setOpenWASettingMenu(false);
    if (highlightMeetingRooms[0] === meetingRoom.id) {
      if (!openMRSettingMenu) {
        setHighlightMeetingRooms([meetingRoom.id]);
        if (filterValue === 3) {
          showMRMenu(meetingRoom, event, true);
        } else {
          showMRMenu(meetingRoom, event);
        }
      } else {
        props.closeMenu();
        setHighlightMeetingRooms([]);
      }
    } else {
      setOpenMRSettingMenu(false);
      setHighlightMeetingRooms([meetingRoom.id]);
    }
    event.stopPropagation();
  };

  const renderWaitingAreasRows = (waitingAreaList, waOnlyView) => {
    if (waitingAreaList && waitingAreaList.length > 0) {
      return waitingAreaList.map((waitingArea, i) => {
        let viewWAMenuCapability = checkViewWAMenuCapability(waitingArea);
        if (!viewWAMenuCapability) {
          return (
            <WaitingAreaRowMarkupWithoutMenu
              key={i}
              index={'WA-' + waitingArea.id}
              isOnMobileOrTablet={props.isOnMobileOrTablet}
              waitingArea={waitingArea}
              waOnlyView={waOnlyView}
            />
          );
        } else {
          return (
            <WaitingAreaRowMarkup
              key={i}
              index={'WA-' + waitingArea.id}
              isOnMobileOrTablet={props.isOnMobileOrTablet}
              waitingArea={waitingArea}
              highlightWaitingAreas={highlightWaitingAreas}
              waTextOnClick={(event) => {
                if (props.isOnMobileOrTablet) {
                  waTextOnClickMobile(event, waitingArea, props.closeMenu);
                } else {
                  waTextOnClickDesktop(event, waitingArea, props.closeMenu);
                }
              }}
              waHamBarOnClick={(event) => {
                if (props.isOnMobileOrTablet) {
                  waHamBarOnClickMobile(event, waitingArea, props.closeMenu);
                } else {
                  waTextOnClickDesktop(event, waitingArea, props.closeMenu);
                }
              }}
              waOnlyView={waOnlyView}
            />
          );
        }
      });
    } else {
      return [];
    }
  };

  const renderMeetingRoomsRows = (meetingRoomList, mrOnlyView) => {
    if (meetingRoomList && meetingRoomList.length > 0) {
      return meetingRoomList.map((meetingRoom, i) => {
        let viewMRMenuCapability = checkViewMRMenuCapability(meetingRoom);
        if (!viewMRMenuCapability) {
          return (
            <MeetingRoomRowMarkupWithoutMenu
              key={i}
              index={'MR-' + meetingRoom.id}
              isOnMobileOrTablet={props.isOnMobileOrTablet}
              meetingRoom={meetingRoom}
              mrOnlyView={mrOnlyView}
            />
          );
        } else {
          return (
            <MeetingRoomRowMarkup
              key={i}
              index={'MR-' + meetingRoom.id}
              isOnMobileOrTablet={props.isOnMobileOrTablet}
              meetingRoom={meetingRoom}
              highlightMeetingRooms={highlightMeetingRooms}
              mrTextOnClick={(event) => {
                if (props.isOnMobileOrTablet) {
                  mrTextOnClickMobile(event, meetingRoom, props.closeMenu);
                } else {
                  mrTextOnClickDesktop(event, meetingRoom, props.closeMenu);
                }
              }}
              mrHamBarOnClick={(event) => {
                if (props.isOnMobileOrTablet) {
                  mrHamBarOnClickMobile(event, meetingRoom, props.closeMenu);
                } else {
                  mrTextOnClickDesktop(event, meetingRoom, props.closeMenu);
                }
              }}
              mrOnlyView={mrOnlyView}
            />
          );
        }
      });
    } else {
      return [];
    }
  };

  const renderOrgUnitRows = (orgUnitList) => {
    if (orgUnitList && orgUnitList.length > 0) {
      const orgUnitRows = orgUnitList.map((orgUnit, i) => {
        let entityType = filterValue === 2 ? 'wa' : filterValue === 3 ? 'mr' : 'org';
        let loadedWAArrayLength =
          orgUnit.waitingAreas == undefined || orgUnit.waitingAreas == [] ? 0 : orgUnit.waitingAreas.length;
        let loadedMRArrayLength =
          orgUnit.meetingRooms == undefined || orgUnit.meetingRooms == [] ? 0 : orgUnit.meetingRooms.length;
        let entityCountMarkup = childEntityCountsMarkup(
          loadedWAArrayLength,
          loadedMRArrayLength,
          orgUnit.waitingAreaCount,
          orgUnit.meetingRoomCount,
          entityType
        );
        let viewOrgMenuCapability = checkViewOrgMenuCapability(orgUnit);
        // Check filterValue to determine what to render
        // OU - first child nodes of tree view
        const orgUnitContent = (
          <OrgUnit1stChildTreeView
            index={i}
            orgUnit={orgUnit}
            isOnMobileOrTablet={props.isOnMobileOrTablet}
            filterValue={filterValue}
            waListContent={renderWaitingAreasRows(orgUnit.waitingAreas, false)}
            mrListContent={renderMeetingRoomsRows(orgUnit.meetingRooms, false)}
            waitingAreas={orgUnit.waitingAreas}
            meetingRooms={orgUnit.meetingRooms}
            dispatch={dispatch}
          />
        );

        if (filterValue === 1) {
          if (orgUnit.waitingAreaCount > 0 || orgUnit.meetingRoomCount > 0) {
            // If it has waiting areas / meeting rooms, show the tree view
            return {
              key: 'OU-' + orgUnit.networkId,
              title: {
                key: 'OU-title-' + i,
                className:
                  'center-flex inline-flex max-width org-row pdtnull pdbnull pdrnull ' +
                  (props.isOnMobileOrTablet ? 'pdlnull ' : '') +
                  (viewOrgMenuCapability && highlightOrgUnits.some((thisOrg) => thisOrg === orgUnit.networkId)
                    ? 'org-selected-row '
                    : 'hover-desktop '),
                content: (
                  <OrgUnitTitleContent
                    viewOrgMenuCapability={viewOrgMenuCapability && filterValue === 1}
                    orgUnit={orgUnit}
                    filterValue={filterValue}
                    isOnMobileOrTablet={props.isOnMobileOrTablet}
                    orgUnitHamBarOnClick={(event) => {
                      if (props.isOnMobileOrTablet) {
                        orgUnitHamBarOnClickMobile(event, orgUnit, props.closeMenu);
                      }
                    }}
                    entityCountMarkup={entityCountMarkup}
                    highlightOrgUnits={highlightOrgUnits}
                    noTreeView={false}
                    isActive={treeViewActiveIndex.some((x) => x.networkId === orgUnit.networkId && x.open === true)}
                  />
                ),
                onClick: (event, itemProps) => {
                  if (!props.isOnMobileOrTablet) {
                    let newIndexArray = [...treeViewActiveIndex];
                    let foundIndex = newIndexArray.findIndex((x) => x.networkId === orgUnit.networkId);
                    props.closeMenu();
                    setHighlightWaitingAreas([]);
                    setHighlightMeetingRooms([]);

                    if (foundIndex > -1) {
                      newIndexArray[foundIndex].open = itemProps.active ? false : true;
                    } else {
                      newIndexArray.push({
                        networkId: orgUnit.networkId,
                        open: itemProps.active ? false : true,
                      });
                    }
                    setTreeViewActiveIndex(newIndexArray);

                    if (highlightOrgUnits[0] === orgUnit.networkId) {
                      setHighlightSelectedOrgUnits([]);
                      props.closeMenu();
                    } else {
                      if (!itemProps.active) {
                        setHighlightSelectedOrgUnits([orgUnit.networkId]);
                        if (!!viewOrgMenuCapability) {
                          setTimeout(() => {
                            showOrgMenu(orgUnit, event);
                          }, 200);
                        }
                      }
                    }
                  } else {
                    let newIndexArray = [...treeViewActiveIndex];
                    let foundIndex = newIndexArray.findIndex((x) => x.networkId === orgUnit.networkId);
                    props.closeMenu();
                    if (highlightOrgUnits[0] === orgUnit.networkId) {
                      setHighlightSelectedOrgUnits([]);
                    } else {
                      setHighlightSelectedOrgUnits([orgUnit.networkId]);
                    }
                  }
                },
              },
              content: {
                key: 'OU-content-' + i,
                className: 'wa-list pdtnull pdbnull pdlnull pdrnull',
                content: orgUnitContent,
              },
            };
          } else {
            // Show the org unit row with close tree view
            return {
              key: 'OU-' + orgUnit.networkId,
              title: {
                key: orgUnit.networkId,
                className:
                  ' center-flex inline-flex max-width org-row pdtnull pdbnull pdrnull pdlnull ' +
                  (viewOrgMenuCapability && highlightOrgUnits.some((thisOrg) => thisOrg === orgUnit.networkId)
                    ? 'org-selected-row '
                    : 'hover-desktop '),
                children: (
                  <OrgUnitTitleContent
                    viewOrgMenuCapability={viewOrgMenuCapability && filterValue === 1}
                    orgUnit={orgUnit}
                    filterValue={filterValue}
                    isOnMobileOrTablet={props.isOnMobileOrTablet}
                    orgUnitHamBarOnClick={(event) => {
                      if (props.isOnMobileOrTablet) {
                        orgUnitHamBarOnClickMobile(event, orgUnit, props.closeMenu);
                      }
                    }}
                    entityCountMarkup={entityCountMarkup}
                    highlightOrgUnits={highlightOrgUnits}
                    noTreeView={true}
                  />
                ),
                onClick: (event, itemProps) => {
                  if (!props.isOnMobileOrTablet) {
                    let newIndexArray = [...treeViewActiveIndex];
                    let foundIndex = newIndexArray.findIndex((x) => x.networkId === orgUnit.networkId);
                    props.closeMenu();
                    setHighlightWaitingAreas([]);
                    setHighlightMeetingRooms([]);

                    if (foundIndex > -1) {
                      newIndexArray[foundIndex].open = itemProps.active ? false : true;
                    } else {
                      newIndexArray.push({
                        networkId: orgUnit.networkId,
                        open: itemProps.active ? false : true,
                      });
                    }
                    setTreeViewActiveIndex(newIndexArray);

                    if (highlightOrgUnits[0] === orgUnit.networkId) {
                      setHighlightSelectedOrgUnits([]);
                      props.closeMenu();
                    } else {
                      if (!itemProps.active) {
                        setHighlightSelectedOrgUnits([orgUnit.networkId]);
                        if (!!viewOrgMenuCapability) {
                          setTimeout(() => {
                            showOrgMenu(orgUnit, event);
                          }, 200);
                        }
                      }
                    }
                  } else {
                    let newIndexArray = [...treeViewActiveIndex];
                    let foundIndex = newIndexArray.findIndex((x) => x.networkId === orgUnit.networkId);

                    if (highlightOrgUnits[0] === orgUnit.networkId) {
                      setHighlightSelectedOrgUnits([]);
                    } else {
                      setHighlightSelectedOrgUnits([orgUnit.networkId]);
                    }
                  }
                },
              },
            };
          }
        } else {
          if (orgUnit.waitingAreaCount > 0 || orgUnit.meetingRoomCount > 0) {
            // If it has waiting areas / meeting rooms, show the tree view
            let isActive = treeViewActiveIndex.some((x) => x.networkId === orgUnit.networkId && x.open === true);
            return {
              key: 'OU-' + orgUnit.networkId,
              title: {
                key: 'OU-title-' + i,
                active: isActive,
                className:
                  ' center-flex inline-flex max-width org-row pdtnull pdbnull pdrnull ' +
                  (props.isOnMobileOrTablet ? 'pdlnull ' : '') +
                  (viewOrgMenuCapability && highlightOrgUnits.some((thisOrg) => thisOrg === orgUnit.networkId)
                    ? 'org-selected-row '
                    : 'hover-desktop '),
                content: (
                  <OrgUnitTitleContent
                    viewOrgMenuCapability={viewOrgMenuCapability && filterValue === 1}
                    orgUnit={orgUnit}
                    filterValue={filterValue}
                    isOnMobileOrTablet={props.isOnMobileOrTablet}
                    orgUnitHamBarOnClick={(event) => {
                      if (props.isOnMobileOrTablet) {
                        orgUnitHamBarOnClickMobile(event, orgUnit, props.closeMenu);
                      }
                    }}
                    entityCountMarkup={entityCountMarkup}
                    highlightOrgUnits={highlightOrgUnits}
                    noTreeView={false}
                  />
                ),
                onClick: (event, itemProps) => {
                  let newIndexArray = [...treeViewActiveIndex];
                  let foundIndex = newIndexArray.findIndex((x) => x.networkId === orgUnit.networkId);
                  props.closeMenu();
                  setHighlightWaitingAreas([]);
                  setHighlightMeetingRooms([]);
                  // If filter is NOT "org unit", it only open/close the tree view
                  if (foundIndex > -1) {
                    newIndexArray[foundIndex].open = itemProps.active ? false : true;
                  } else {
                    newIndexArray.push({
                      networkId: orgUnit.networkId,
                      open: itemProps.active ? false : true,
                    });
                  }
                  setTreeViewActiveIndex(newIndexArray);
                },
              },
              content: {
                key: 'OU-content-' + i,
                active: isActive,
                className: 'wa-list pdtnull pdbnull pdlnull pdrnull',
                content:
                  filterValue == 2
                    ? renderWaitingAreasRows(orgUnit.waitingAreas, true)
                    : renderMeetingRoomsRows(orgUnit.meetingRooms, true),
              },
            };
          } else {
            // Show the org unit row with close tree view
            return {
              key: 'OU-' + orgUnit.networkId,
              title: {
                key: 'OU-title-' + i,
                className:
                  ' center-flex inline-flex max-width org-row pdtnull pdbnull pdrnull pdlnull ' +
                  (viewOrgMenuCapability && highlightOrgUnits.some((thisOrg) => thisOrg === orgUnit.networkId)
                    ? 'org-selected-row '
                    : 'hover-desktop '),
                childern: (
                  <OrgUnitTitleContent
                    viewOrgMenuCapability={viewOrgMenuCapability && filterValue === 1}
                    orgUnit={orgUnit}
                    filterValue={filterValue}
                    isOnMobileOrTablet={props.isOnMobileOrTablet}
                    orgUnitHamBarOnClick={(event) => {
                      if (props.isOnMobileOrTablet) {
                        orgUnitHamBarOnClickMobile(event, orgUnit, props.closeMenu);
                      }
                    }}
                    entityCountMarkup={entityCountMarkup}
                    highlightOrgUnits={highlightOrgUnits}
                    noTreeView={true}
                  />
                ),
                onClick: (event, itemProps) => {
                  let newIndexArray = [...treeViewActiveIndex];
                  let foundIndex = newIndexArray.findIndex((x) => x.networkId === orgUnit.networkId);
                  props.closeMenu();
                  setHighlightWaitingAreas([]);
                  setHighlightMeetingRooms([]);
                  // If filter is NOT "org unit", it only open/close the tree view
                  if (foundIndex > -1) {
                    newIndexArray[foundIndex].open = itemProps.active ? false : true;
                  } else {
                    newIndexArray.push({
                      networkId: orgUnit.networkId,
                      open: itemProps.active ? false : true,
                    });
                  }
                  setTreeViewActiveIndex(newIndexArray);
                },
              },
            };
          }
        }
      });

      return (
        <Accordion
          panels={orgUnitRows}
          exclusive={filterValue === 1 ? true : false}
          fluid
          styled
          className={props.isOnMobileOrTablet ? '' : 'pdlnull pdrnull'}
        />
      );
    } else {
      return fetchingOrgs ? '' : <NoResultMarkUp isOnMobileOrTablet={props.isOnMobileOrTablet} />;
    }
  };

  let isSearchTermEmpty = getSearchString() === '';

  // Page view on mobiles & tablets
  if (!!props.isOnMobileOrTablet) {
    return (
      <div className="ui padded grid small-device-scrolling-wrapper">
        <div className={'row flexible pdtnull pdbnull header-row color-organisational-unit-bg '}>
          <span className="ui eight wide tablet only column color-white display-flex">
            <FilterDropdownMarkUp
              entityAdminRights={props.entityAdminRights}
              useShortText={false}
              filterValue={filterValue}
              filterOnChange={filterOnChange}
              disabled={fetchingOrgs}
            />
          </span>
          <span className="ui eight wide mobile only column color-white display-flex pdrxs">
            <FilterDropdownMarkUp
              entityAdminRights={props.entityAdminRights}
              useShortText={true}
              filterValue={filterValue}
              filterOnChange={filterOnChange}
              disabled={fetchingOrgs}
            />
          </span>
          <span className="ui eight wide mobile only column icon input color-white display-flex pdlxs">
            <SearchContainer
              onChange={onSearchTermInputChange}
              id="searchBarInputEntity"
              className={'ui color-white input max-width pdxs color-organisational-unit-bg-highlight '}
              maxlength="500"
              onKeyUpHandler={() => {
                newSearchDone();
              }}
              placeholder={APP.LANGUAGE.EntityAdmin.SearchPlaceholder}
              autoComplete="not-enable"
              disabled={fetchingOrgs}
            />
            {!searchTermSubmitted || isSearchTermEmpty ? (
              <i className="search icon mrrml hand" onClick={submitSearchTerm} style={{ pointerEvents: 'auto' }} />
            ) : (
              <i
                className="delete icon mrrml hand"
                onClick={clearSearchTerm}
                style={{
                  pointerEvents: 'auto',
                  opacity: !fetchingOrgs ? 1 : '',
                }}
              />
            )}
          </span>
          <span className="ui eight wide tablet only column icon input color-white display-flex">
            <SearchContainer
              onChange={onSearchTermInputChange}
              id="searchBarInputEntity"
              className={'ui color-white input max-width pdxs color-organisational-unit-bg-highlight '}
              maxlength="500"
              onKeyUpHandler={() => {
                newSearchDone();
              }}
              placeholder={APP.LANGUAGE.EntityAdmin.SearchPlaceholder}
              autoComplete="not-enable"
              disabled={fetchingOrgs}
            />
            {!searchTermSubmitted || isSearchTermEmpty ? (
              <i className="search icon mrrml hand" onClick={submitSearchTerm} style={{ pointerEvents: 'auto' }} />
            ) : (
              <i
                className="delete icon mrrml hand"
                onClick={clearSearchTerm}
                style={{
                  pointerEvents: 'auto',
                  opacity: !fetchingOrgs ? 1 : '',
                }}
              />
            )}
          </span>
        </div>
        {renderOrgUnitRows(props.organisations)}
        <Waypoint onEnter={handleWaypointEnter}>
          <div className="waypoint mrts mrbs" />
        </Waypoint>
        {fetchingOrgs ? (
          <div className="mrtm mrbm max-width">
            <Loader active inline="centered" />
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }

  // Page view on desktop
  return (
    <div className="pdlm pdrm">
      <div className="ui padded grid">
        <div className={'row flexible pdtnull pdbnull header-row color-organisational-unit-bg '}>
          <span className="ui eight wide computer only column color-white display-flex">
            <FilterDropdownMarkUp
              entityAdminRights={props.entityAdminRights}
              useShortText={false}
              filterValue={filterValue}
              filterOnChange={filterOnChange}
              disabled={fetchingOrgs}
            />
          </span>
          <span className="ui eight wide tablet eight wide computer sixteen wide mobile column  icon input color-white display-flex">
            <SearchContainer
              onChange={onSearchTermInputChange}
              id="searchBarInputEntity"
              className={'ui color-white input max-width pdxs color-organisational-unit-bg-highlight '}
              maxlength="500"
              onKeyUpHandler={() => {
                newSearchDone();
              }}
              placeholder={
                filterValue === 1
                  ? APP.LANGUAGE.EntityAdmin.SearchPlaceholder
                  : filterValue === 2
                  ? APP.LANGUAGE.EntityAdmin.SearchWAPlaceholder
                  : APP.LANGUAGE.EntityAdmin.SearchMRPlaceholder
              }
              autoComplete="not-enable"
              disabled={fetchingOrgs}
            />
            {!searchTermSubmitted || isSearchTermEmpty ? (
              <i className="search icon mrrml hand" onClick={submitSearchTerm} style={{ pointerEvents: 'auto' }} />
            ) : (
              <i
                className="delete icon mrrml hand"
                onClick={clearSearchTerm}
                style={{
                  pointerEvents: 'auto',
                  opacity: !fetchingOrgs ? 1 : '',
                }}
              />
            )}
          </span>
        </div>
      </div>
      <div className="desktop-scrolling-wrapper">
        <div className="ui center aligned padded grid pdlnull pdrnull" id="desktop-scrolling-wrapper-users">
          {
            <div className="row flexible row-hoverable" /> /* Have to add this empty div with .row class, to show the bottom border for other rows */
          }
          {renderOrgUnitRows(props.organisations)}
          {fetchingOrgs ? (
            <div className="mrtm mrbxl">
              <Loader active inline="centered" />
            </div>
          ) : (
            <div className="flexible" style={{ height: '150px' }} />
          )}
          <Waypoint onEnter={handleWaypointEnter}>
            <div className="waypoint" />
          </Waypoint>
        </div>
        <ScrollToTopButton
          className="scroll-top-btn-mobile"
          targetElement=".desktop-scrolling-wrapper-users"
          style={{ right: '40px', bottom: '20px' }}
        />
      </div>
    </div>
  );
}
